import { render, staticRenderFns } from "./TinTucList.vue?vue&type=template&id=5b27af18&"
import script from "./TinTucList.vue?vue&type=script&lang=js&"
export * from "./TinTucList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports